import {Utils} from "./Utils";

export class EmployeeFamilyDays {
  id: number;
  employeeId: string;
  startDate: Date;
  endDate: Date;
  nbPaidDays: number;
  nbPaidDaysUsed: number;
  nbUnPaidDays: number;
  nbUnPaidDaysUsed: number;
  note = '';
  lastModificationOn: Date;
  lastModificationBy = '';


  public inRightPeriod(dtRef: Date):boolean{
    if (Utils.isNullOrUndefined(this.startDate) || Utils.isNullOrUndefined(this.endDate) || Utils.isNullOrUndefined(dtRef)){
      return true;
      // return this.active;
    }
    if (Utils.isAfterRefDate(dtRef,this.startDate)){
      if (Utils.isBeforeRefDate(dtRef,this.endDate)){
        return true;
      }
    }
    return false;
  }


}
